<script>
import {
  ccp_amount_type,
  percentages,
  when_to_authorize,
  when_booking,
  when_booking_on_security_deposit,
  cancellation_fee_within,
  cancellation_fee,
  cancelled_within,
  reservation_amount_type,
} from "@/helpers/global.variable";
import UserService from "@/helpers/APIService/user.service";
import { required } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  data() {
    return {
      ccp_amount_type,
      percentages,
      when_to_authorize,
      when_booking,
      when_booking_on_security_deposit,
      cancellation_fee_within,
      reservation_amount_type,
      initialize_cancellation_fee: cancellation_fee,
      cancellation_fee: [cancellation_fee],
      initialize_cancelled_within: cancelled_within,
      cancelled_within: [cancelled_within],
      credit_card_validation: {
        id: null,
        amount_type: null,
        amount: 1.0,
        percentage: 0,
        when_to_authorized: null,
        is_chargeBack_protection: null,
        is_re_authorize_in_seven_day: null,
      },
      reservation_payment: {
        id: null,
        amount_type: null,
        percentage: null,
        when_to_authorized: null,
        when: null,
        remaining_payment_when_to_authorized: null,
        remaining_payment_when: null,
        is_chargeBack_protection: null,
        is_remaining_payment_chargeBack_protection: null,
      },
      reservation_paymentPercentage: "",
      security_deposit: {
        id: null,
        amount_type: null,
        amount: "1.00",
        percentage: null,
        when: "BCI",
        when_to_authorized: null,
        is_chargeBack_protection: null,
        is_re_authorize_in_seven_day: null,
      },
      cancellation_policy: {
        id: null,
        when_full_refund: "BCI",
        when_to_full_refund: null,
        is_error: false,
        error_message: "",
      },
      initialize_cancellation_policy_charge: [
        {
          cancellation_policy: null,
          cancellation_fee: null,
          cancelled_within: null,
          flat_fee: 1.0,
        },
      ],
      cancellation_policy_charge: [
        {
          cancellation_policy: null,
          cancellation_fee: 80,
          cancelled_within: 0,
          flat_fee: 0.0,
        },
      ],
      is_credit_card_validation: false,
      is_reservation_payment: false,
      is_security_deposit: false,
      is_cancellation_policy: false,
      is_active: false,
      submitted: false,
      isBtnLoading: false,
      current_index: 0,
      current_cancelled_fee: 0,
      current_cancelled_within: 0,
    };
  },
  validations: {
    credit_card_validation: {
      amount_type: {
        required,
      },
      percentage: {
        required,
      },
      amount: {
        required,
      },
      when_to_authorized: {
        required,
      },
    },
    reservation_payment: {
      amount_type: {
        required,
      },
      percentage: {
        required,
      },
      when_to_authorized: {
        required,
      },
      when: {
        required,
      },
      remaining_payment_when_to_authorized: {
        required,
      },
      remaining_payment_when: { required },
    },
    security_deposit: {
      amount_type: {
        required,
      },
      percentage: {
        required,
      },
      amount: {
        required,
      },
      when: {
        required,
      },
      when_to_authorized: {
        required,
      },
    },
    cancellation_policy: {
      when_to_full_refund: {
        required,
      },
    },
    cancellation_policy_charge: {
      required,
      $each: {
        cancellation_fee: { required },
        cancelled_within: { required },
        flat_fee: { required },
      },
    },
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  mounted() {
    this.getBookingSourcePolicyDetails();
  },
  methods: {
    getBookingSourcePolicyDetails() {
      UserService.getBookingSourcePaymentRule(
        this.currentProps.selectedBookingSource
      )
        .then((booking_source_details) => {
          this.credit_card_validation.id =
            booking_source_details.credit_card_validation.id;
          this.credit_card_validation.amount_type =
            booking_source_details.credit_card_validation.amount_type;
          this.credit_card_validation.amount =
            booking_source_details.credit_card_validation.amount;
          this.credit_card_validation.percentage =
            booking_source_details.credit_card_validation.percentage;
          this.credit_card_validation.when_to_authorized =
            booking_source_details.credit_card_validation.when_to_authorized;
          this.credit_card_validation.is_chargeBack_protection =
            booking_source_details.credit_card_validation.is_chargeBack_protection;
          this.credit_card_validation.is_re_authorize_in_seven_day =
            booking_source_details.credit_card_validation.is_re_authorize_in_seven_day;

          this.reservation_payment.id =
            booking_source_details.reservation_payment.id;
          this.reservation_payment.amount_type =
            booking_source_details.reservation_payment.amount_type;
          this.reservation_payment.percentage =
            booking_source_details.reservation_payment.percentage;
          this.reservation_paymentPercentage =
            booking_source_details.reservation_payment.percentage;
          this.reservation_payment.when_to_authorized =
            booking_source_details.reservation_payment.when_to_authorized;
          this.reservation_payment.when =
            booking_source_details.reservation_payment.when;
          this.reservation_payment.remaining_payment_when_to_authorized =
            booking_source_details.reservation_payment.remaining_payment_when_to_authorized;
          this.reservation_payment.remaining_payment_when =
            booking_source_details.reservation_payment.remaining_payment_when;
          this.reservation_payment.is_chargeBack_protection =
            booking_source_details.reservation_payment.is_chargeBack_protection;
          this.reservation_payment.is_remaining_payment_chargeBack_protection =
            booking_source_details.reservation_payment.is_remaining_payment_chargeBack_protection;

          this.security_deposit.id = booking_source_details.security_deposit.id;
          this.security_deposit.amount_type =
            booking_source_details.security_deposit.amount_type;
          this.security_deposit.amount =
            booking_source_details.security_deposit.amount;
          this.security_deposit.percentage =
            booking_source_details.security_deposit.percentage;
          if (booking_source_details.security_deposit.when !== "") {
            this.security_deposit.when =
              booking_source_details.security_deposit.when;
          }
          this.security_deposit.when_to_authorized =
            booking_source_details.security_deposit.when_to_authorized;
          this.security_deposit.is_chargeBack_protection =
            booking_source_details.security_deposit.is_chargeBack_protection;
          this.security_deposit.is_re_authorize_in_seven_day =
            booking_source_details.security_deposit.is_re_authorize_in_seven_day;

          this.cancellation_policy.id =
            booking_source_details.cancellation_policy.id;
          if (
            booking_source_details.cancellation_policy
              .cancellation_policy_charge.length > 0
          ) {
            this.cancellation_policy_charge =
              booking_source_details.cancellation_policy.cancellation_policy_charge;

            for (
              let i = 0;
              i <
              booking_source_details.cancellation_policy
                .cancellation_policy_charge.length;
              i++
            ) {
              if (
                this.cancellation_fee.length <
                booking_source_details.cancellation_policy
                  .cancellation_policy_charge.length
              ) {
                this.cancellation_fee.push(this.initialize_cancellation_fee);
              }
              if (
                this.cancelled_within.length <
                booking_source_details.cancellation_policy
                  .cancellation_policy_charge.length
              ) {
                this.cancelled_within.push(this.initialize_cancelled_within);
              }
            }
          } else {
            this.cancellation_policy_charge[0].cancellation_policy =
              booking_source_details.cancellation_policy.id;
          }
          this.cancellation_policy.when_full_refund =
            booking_source_details.cancellation_policy.when_full_refund;
          this.cancellation_policy.when_to_full_refund =
            booking_source_details.cancellation_policy.when_to_full_refund;

          this.is_credit_card_validation =
            booking_source_details.is_credit_card_validation;
          this.is_reservation_payment =
            booking_source_details.is_reservation_payment;
          this.is_security_deposit = booking_source_details.is_security_deposit;
          this.is_cancellation_policy =
            booking_source_details.is_cancellation_policy;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        this.cancellation_policy.cancellation_policy_charge =
          this.cancellation_policy_charge;
        if (
          this.is_credit_card_validation ||
          this.is_reservation_payment ||
          this.is_security_deposit ||
          this.is_cancellation_policy
        ) {
          this.is_active = true;
        }
        let policyData = {};
        if (this.is_credit_card_validation) {
          policyData.credit_card_validation = this.credit_card_validation;
        }
        if (this.is_security_deposit) {
          policyData.security_deposit = this.security_deposit;
        }
        if (this.is_reservation_payment) {
          policyData.reservation_payment = this.reservation_payment;
        }
        if (this.is_cancellation_policy) {
          policyData.cancellation_policy = this.cancellation_policy;
        }
        policyData.is_active = this.is_active;
        policyData.is_credit_card_validation = this.is_credit_card_validation;
        policyData.is_reservation_payment = this.is_reservation_payment;
        policyData.is_security_deposit = this.is_security_deposit;
        policyData.is_cancellation_policy = this.is_cancellation_policy;
        hotelService
          .updateBookingPaymentRule(
            policyData,
            this.currentProps.selectedBookingSource
          )
          .then(() => {
            this.cancellation_policy.is_error = false;
            this.isBtnLoading = false;
            this.submitted = false;
            this.$emit("submitted");
          })
          .catch((error) => {
            errorHandler(error);
            this.isBtnLoading = false;
            this.cancellation_policy.is_error = true;
            if (error.response.data.cancellation_policy) {
              this.cancellation_policy.error_message =
                error.response.data.cancellation_policy.cancellation_policy_charge;
            }
          });
      }
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    addCancellationPolicyCharge() {
      let length = this.cancellation_policy_charge.length;
      let oldLength = length - 1;
      let demos = [];

      this.cancelled_within[oldLength].map((item) => {
        if (
          item.value >
          this.cancellation_policy_charge[oldLength].cancelled_within
        ) {
          demos.push(item);
        }
      });

      let demos1 = [];
      this.cancellation_fee[oldLength].map((item) => {
        if (
          item.value <
          this.cancellation_policy_charge[oldLength].cancellation_fee
        ) {
          demos1.push(item);
        }
      });

      this.cancellation_policy_charge.push({
        cancellation_policy: this.cancellation_policy.id,
        cancellation_fee: "",
        cancelled_within: "",
        flat_fee: 0.0,
      });
      this.cancellation_fee[length] = demos1;
      this.cancelled_within[length] = demos;
    },
    deleteCancellationPolicyCharge(index) {
      this.cancellation_policy_charge.splice(index, 1);
      this.cancellation_fee.splice(index, 1);
      this.cancelled_within.splice(index, 1);
    },
    changeReservationPaymentPercentage(reservation_paymentPercentage) {
      this.reservation_paymentPercentage = reservation_paymentPercentage;
    },
    myMethod(data) {
      let demos = [];
      this.initialize_cancelled_within.map((item) => {
        if (item.value < data) {
          demos.push(item);
        }
      });

      let demos1 = [];
      this.initialize_cancellation_fee.map((item) => {
        demos1.push(item);
      });

      this.cancellation_fee[0] = demos1;
      this.cancelled_within[0] = demos;

      this.cancellation_policy_charge.splice(1);
      this.cancellation_fee.splice(1);
      this.cancelled_within.splice(1);
    },
    changeInCancellationFee(index) {
      let demos1 = [];
      this.cancellation_fee[index].map((item) => {
        if (
          item.value < this.cancellation_policy_charge[index].cancellation_fee
        ) {
          demos1.push(item);
        }
      });
      this.cancellation_fee[index + 1] = demos1;

      this.cancellation_policy_charge.splice(index + 2);
      this.cancellation_fee.splice(index + 2);
      this.cancelled_within.splice(index + 2);
    },
    changeInCancelledWithin(index) {
      let demos = [];

      this.cancelled_within[index].map((item) => {
        if (
          item.value > this.cancellation_policy_charge[index].cancelled_within
        ) {
          demos.push(item);
        }
      });
      if (typeof this.cancellation_policy_charge[index + 1] !== "undefined") {
        this.cancellation_policy_charge[index + 1].cancelled_within = null;
      }
      this.cancelled_within[index + 1] = demos;

      this.cancellation_policy_charge.splice(index + 2);
      this.cancellation_fee.splice(index + 2);
      this.cancelled_within.splice(index + 2);
    },
  },
};
</script>

<template>
  <div class="offcanvas-body">
    <b-form class="tablist">
      <!-- Credit card validation -->
      <div class="row">
        <div class="col-12">
          <b-card no-body>
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.cardValidation
            >
              <h6 class="float-start mt-2" slot="header">
                Credit Card Validation (Booking Guarantee)
              </h6>
              <div class="form-check form-switch form-switch-md float-end">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="credit_card"
                  v-model="is_credit_card_validation"
                  variant="primary"
                />
              </div>
              <span
                v-if="submitted && $v.credit_card_validation.$invalid"
                class="me-2 my-1 badge align-items-center card-badge badge-soft-danger float-end"
              >
                <b>Credit Card validation Have Error</b>
              </span>
            </b-card-header>
            <b-collapse
              id="cardValidation"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-md-12">
                      <p class="text-blue">
                        <b>How much to authorize?</b>
                      </p>
                      <div class="row">
                        <div class="col-md-5">
                          <b-form-group
                            class="mb-3 form-label"
                            label="Amount Type"
                            label-for="credit-card-validation-amount-type"
                          >
                            <template slot="label">
                              Amount Type <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              v-model="credit_card_validation.amount_type"
                              class="form-select"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.credit_card_validation.amount_type.$error,
                              }"
                              :options="ccp_amount_type"
                              type="text"
                              autocomplete="off"
                              id="credit-card-validation-amount-type"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.credit_card_validation.amount_type.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.credit_card_validation.amount_type
                                    .required
                                "
                                >amount type is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div
                          class="col-md-5 ccv_amount_cls"
                          v-if="credit_card_validation.amount_type === 'FA'"
                        >
                          <b-form-group
                            class="mb-3"
                            label="Amount"
                            label-for="credit-card-validation-amount"
                          >
                            <template slot="label">
                              Amount <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                              id="credit-card-validation-amount"
                              v-model="credit_card_validation.amount"
                              type="number"
                              autocomplete="off"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.credit_card_validation.amount.$error,
                              }"
                            ></b-form-input>
                            <div
                              v-if="
                                submitted &&
                                $v.credit_card_validation.amount.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.credit_card_validation.amount.required
                                "
                                >amount is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div
                          class="col-md-2 ccv_percentage_cls"
                          v-if="credit_card_validation.amount_type === 'PBA'"
                        >
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="Percentage"
                            label-for="credit-card-validation-percentage"
                          >
                            <template slot="label">
                              Percentage <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              v-model="credit_card_validation.percentage"
                              class="form-select"
                              id="credit-card-validation-percentage"
                              type="text"
                              autocomplete="off"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.credit_card_validation.percentage.$error,
                              }"
                              :options="percentages"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.credit_card_validation.percentage.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.credit_card_validation.percentage.required
                                "
                                >percentage is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <p class="mt-3 mb-2 text-blue">
                        <b
                          >When to authorize?
                          <span class="text-danger">*</span></b
                        >
                      </p>
                      <div class="row">
                        <div class="col-md-5">
                          <b-form-select
                            class="form-select"
                            id="credit-card-validation-when-to-authorise"
                            type="text"
                            autocomplete="off"
                            :options="when_to_authorize"
                            v-model="credit_card_validation.when_to_authorized"
                            :class="{
                              'is-invalid':
                                submitted &&
                                $v.credit_card_validation.when_to_authorized
                                  .$error,
                            }"
                          >
                          </b-form-select>
                          <div
                            v-if="
                              submitted &&
                              $v.credit_card_validation.when_to_authorized
                                .$error
                            "
                            class="invalid-feedback"
                          >
                            <span
                              v-if="
                                !$v.credit_card_validation.when_to_authorized
                                  .required
                              "
                              >when to authorise time is required.</span
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <p class="mb-0 text-dark"><b> After Booking </b></p>
                        </div>
                      </div>
                      <div class="form-check d-inline-block mt-3">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="
                            credit_card_validation.is_re_authorize_in_seven_day
                          "
                          id="credit-card-validation-re-authorise-seven-days"
                        />
                        <label
                          class="form-check-label"
                          for="credit-card-validation-re-authorise-seven-days"
                          >Automatically re-authorize every seven days</label
                        >
                      </div>
                      <br />
                      <div class="form-check d-inline-block mt-3">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="
                            credit_card_validation.is_chargeBack_protection
                          "
                          id="credit-card-validation-chargeback-protection"
                        />
                        <label
                          class="form-check-label"
                          for="credit-card-validation-chargeback-protection"
                          >Charge Back protection</label
                        >
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <!-- reservation payment -->
      <div class="row">
        <div class="col-12">
          <b-card no-body>
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.reservation
            >
              <h6 class="float-start mt-2" slot="header">
                Reservation Payment
              </h6>
              <div class="form-check form-switch form-switch-md float-end">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SwitchCheckSizemd"
                  v-model="is_reservation_payment"
                  variant="primary"
                />
              </div>
              <span
                v-if="submitted && $v.reservation_payment.$invalid"
                class="me-2 my-1 badge align-items-center card-badge badge-soft-danger float-end"
              >
                <b>Reservation Payment Have Error</b>
              </span>
            </b-card-header>
            <b-collapse
              accordion="my-accordion"
              role="tabpanel"
              id="reservation"
              class="mt-1"
            >
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-12">
                      <p class="text-blue">
                        <b>Collect booking amount</b>
                      </p>
                      <div class="row">
                        <div class="col-md-4">
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="Amount Type"
                            label-for="reservation-amount-typ"
                          >
                            <template slot="label">
                              Amount Type <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="reservation-amount-typ"
                              type="text"
                              autocomplete="off"
                              v-model="reservation_payment.amount_type"
                              :options="reservation_amount_type"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.reservation_payment.amount_type.$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.reservation_payment.amount_type.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.reservation_payment.amount_type.required
                                "
                                >amount type is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div
                          class="col-md-2 rp_percentage_cls"
                          v-if="reservation_payment.amount_type === 'PBA'"
                        >
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="Percentage"
                            label-for="reservation-percentage"
                          >
                            <template slot="label">
                              Percentage <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="reservation-percentage"
                              type="text"
                              autocomplete="off"
                              v-model="reservation_payment.percentage"
                              :options="percentages"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.reservation_payment.percentage.$error,
                              }"
                              @change="
                                changeReservationPaymentPercentage(
                                  reservation_payment.percentage
                                )
                              "
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.reservation_payment.percentage.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.reservation_payment.percentage.required
                                "
                                >percentage is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="When To Authorized"
                            label-for="reservation-when-to-authorise"
                          >
                            <template slot="label">
                              When To Authorized
                              <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="reservation-when-to-authorise"
                              type="text"
                              autocomplete="off"
                              :options="when_to_authorize"
                              v-model="reservation_payment.when_to_authorized"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.reservation_payment.when_to_authorized
                                    .$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.reservation_payment.when_to_authorized.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.reservation_payment.when_to_authorized
                                    .required
                                "
                                >when to authorise time is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="When"
                            label-for="reservation-when"
                          >
                            <template slot="label">
                              When <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="reservation-when"
                              type="text"
                              autocomplete="off"
                              :options="when_booking"
                              v-model="reservation_payment.when"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.reservation_payment.when.$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted && $v.reservation_payment.when.$error
                              "
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.reservation_payment.when.required"
                                >when is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div
                          :class="
                            reservation_payment.amount_type !== 'PBA' ||
                            reservation_paymentPercentage !== 100
                              ? 'col-md-4 mt-2'
                              : 'd-none'
                          "
                        >
                          <div class="form-check d-inline-block">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              v-model="
                                reservation_payment.is_chargeBack_protection
                              "
                              id="reservation_is_chargeback_protection"
                            />
                            <label
                              class="form-check-label"
                              for="reservation_is_chargeback_protection"
                              >Charge Back Protection</label
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        :class="
                          reservation_payment.amount_type !== 'PBA' ||
                          reservation_paymentPercentage !== 100
                            ? 'row mt-4 rp_remaining_balance_row align-items-center'
                            : 'd-none'
                        "
                      >
                        <div class="col-md-4">
                          <b-form-group
                            class="form-label"
                            id="input-group-1"
                            label="Remaining Balance"
                            label-for="rp_remaining_balance"
                          >
                            <template slot="label">
                              Remaining Balance
                              <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="rp_remaining_balance"
                              type="text"
                              autocomplete="off"
                              :options="when_to_authorize"
                              v-model="
                                reservation_payment.remaining_payment_when_to_authorized
                              "
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.reservation_payment
                                    .remaining_payment_when_to_authorized
                                    .$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.reservation_payment
                                  .remaining_payment_when_to_authorized.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.reservation_payment
                                    .remaining_payment_when_to_authorized
                                    .required
                                "
                                >remaining balance paying time is
                                required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>

                        <div class="col-md-4">
                          <b-form-group
                            class="form-label"
                            id="input-group-1"
                            label="When"
                            label-for="reservation-when"
                          >
                            <template slot="label">
                              When <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="reservation-when"
                              type="text"
                              autocomplete="off"
                              :options="when_booking_on_security_deposit"
                              v-model="
                                reservation_payment.remaining_payment_when
                              "
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.reservation_payment.remaining_payment_when
                                    .$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.reservation_payment.remaining_payment_when
                                  .$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.reservation_payment.remaining_payment_when
                                    .required
                                "
                                >when is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <div class="form-check d-inline-block">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="rp_is_chargeback_protection_remaining_balance"
                              v-model="
                                reservation_payment.is_remaining_payment_chargeBack_protection
                              "
                            />
                            <label
                              class="form-check-label"
                              for="rp_is_chargeback_protection_remaining_balance"
                              >Charge Back Protection</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <!-- security deposit -->
      <div class="row">
        <div class="col-12">
          <b-card no-body>
            <b-card-header header-tag="header" role="tab" v-b-toggle.security>
              <h6 class="float-start mt-2" slot="header">Security Deposit</h6>
              <div class="form-check form-switch form-switch-md float-end">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SwitchCheckSizemd"
                  v-model="is_security_deposit"
                  variant="primary"
                />
              </div>
              <span
                v-if="submitted && $v.security_deposit.$invalid"
                class="me-2 my-1 badge align-items-center card-badge badge-soft-danger float-end"
              >
                <b>Security Deposit Have Error</b>
              </span>
            </b-card-header>
            <b-collapse id="security" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-12">
                      <p class="text-blue">
                        <b>How much to authorize?</b>
                      </p>
                      <div class="row">
                        <div class="col-md-5">
                          <b-form-group
                            class="mb-3 form-label"
                            label="Amount Type"
                            label-for="credit-card-validation-amount-type"
                          >
                            <template slot="label">
                              Amount Type <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              v-model="security_deposit.amount_type"
                              class="form-select"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.security_deposit.amount_type.$error,
                              }"
                              :options="ccp_amount_type"
                              type="text"
                              autocomplete="off"
                              id="credit-card-validation-amount-type"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.security_deposit.amount_type.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="!$v.security_deposit.amount_type.required"
                                >amount type is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div
                          class="col-md-5 ccv_amount_cls"
                          v-if="security_deposit.amount_type === 'FA'"
                        >
                          <b-form-group
                            class="mb-3"
                            label="Amount"
                            label-for="credit-card-validation-amount"
                          >
                            <template slot="label">
                              Amount <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                              id="credit-card-validation-amount"
                              v-model="security_deposit.amount"
                              step="0.01"
                              type="number"
                              autocomplete="off"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.security_deposit.amount.$error,
                              }"
                            ></b-form-input>
                            <div
                              v-if="
                                submitted && $v.security_deposit.amount.$error
                              "
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.security_deposit.amount.required"
                                >amount is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div
                          class="col-md-2 ccv_percentage_cls"
                          v-if="security_deposit.amount_type === 'PBA'"
                        >
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="Percentage"
                            label-for="credit-card-validation-percentage"
                          >
                            <template slot="label">
                              Percentage <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              v-model="security_deposit.percentage"
                              class="form-select"
                              id="credit-card-validation-percentage"
                              type="text"
                              autocomplete="off"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.security_deposit.percentage.$error,
                              }"
                              :options="percentages"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.security_deposit.percentage.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="!$v.security_deposit.percentage.required"
                                >percentage is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                      </div>

                      <p class="mt-3 mb-2 text-blue">
                        <b>When to authorize?</b>
                      </p>
                      <div class="row">
                        <div class="col-md-5">
                          <b-form-group
                            class="mb-3 form-label"
                            label="When To Authorized"
                            label-for="credit-card-validation-amount-type"
                          >
                            <template slot="label">
                              When To Authorized
                              <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="credit-card-validation-when-to-authorise"
                              type="text"
                              autocomplete="off"
                              :options="when_to_authorize"
                              v-model="security_deposit.when_to_authorized"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.security_deposit.when_to_authorized.$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted &&
                                $v.security_deposit.when_to_authorized.$error
                              "
                              class="invalid-feedback"
                            >
                              <span
                                v-if="
                                  !$v.security_deposit.when_to_authorized
                                    .required
                                "
                                >when to authorise time is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group
                            class="mb-3 form-label"
                            id="input-group-1"
                            label="When"
                            label-for="reservation-when"
                          >
                            <template slot="label">
                              When <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              class="form-select"
                              id="reservation-when"
                              type="text"
                              autocomplete="off"
                              :options="when_booking_on_security_deposit"
                              v-model="security_deposit.when"
                              :class="{
                                'is-invalid':
                                  submitted && $v.security_deposit.when.$error,
                              }"
                            >
                            </b-form-select>
                            <div
                              v-if="
                                submitted && $v.security_deposit.when.$error
                              "
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.security_deposit.when.required"
                                >when is required.</span
                              >
                            </div>
                          </b-form-group>
                        </div>
                      </div>

                      <div class="form-check d-inline-block mt-3">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="
                            security_deposit.is_re_authorize_in_seven_day
                          "
                          id="security-deposit-re-authorise-seven-days"
                        />
                        <label
                          class="form-check-label"
                          for="security-deposit-re-authorise-seven-days"
                          >Automatically re-authorize every seven days</label
                        >
                      </div>
                      <br />
                      <div class="form-check d-inline-block mt-3">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="security_deposit.is_chargeBack_protection"
                          id="security-deposit-chargeback-protection"
                        />
                        <label
                          class="form-check-label"
                          for="security-deposit-chargeback-protection"
                          >Charge Back protection</label
                        >
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <!-- cancellation policy -->
      <div class="row">
        <div class="col-12">
          <b-card no-body>
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.cancellation
            >
              <h6 class="float-start mt-2" slot="header">
                Cancellation Policy
              </h6>
              <div class="form-check form-switch form-switch-md float-end">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="SwitchCheckSizemd"
                  v-model="is_cancellation_policy"
                  variant="primary"
                />
              </div>
              <span
                v-if="
                  submitted &&
                  ($v.cancellation_policy.$invalid ||
                    $v.cancellation_policy_charge.$invalid)
                "
                class="me-2 my-1 badge align-items-center card-badge badge-soft-danger float-end"
              >
                <b>Cancellation Policy Have Error</b>
              </span>
            </b-card-header>
            <b-collapse
              id="cancellation"
              class="mt-1"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-12">
                      <p class="text-blue">
                        <b class="me-1"
                          >Guests are not charged a fee if they cancel</b
                        >
                        <i
                          class="fa fa-info-circle text-muted"
                          tabindex="0"
                          data-plugin="tippy"
                          data-tippy-animation="scale"
                          data-tippy-arrow="true"
                          v-b-popover.hover="
                            'Any collected reservation payment will be refunded automatically.'
                          "
                        ></i>
                      </p>
                      <div class="row">
                        <div class="col-md-5">
                          <b-form-select
                            class="form-select"
                            id="cp_after_booking_no_charge"
                            type="text"
                            autocomplete="off"
                            :options="cancellation_fee_within"
                            v-model="cancellation_policy.when_to_full_refund"
                            v-on:change="
                              myMethod(cancellation_policy.when_to_full_refund)
                            "
                            :class="{
                              'is-invalid':
                                submitted &&
                                $v.cancellation_policy.when_to_full_refund
                                  .$error,
                            }"
                          >
                          </b-form-select>
                          <div
                            v-if="
                              submitted &&
                              $v.cancellation_policy.when_to_full_refund.$error
                            "
                            class="invalid-feedback"
                          >
                            <span
                              v-if="
                                !$v.cancellation_policy.when_to_full_refund
                                  .required
                              "
                              >when to full refund time is required.</span
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <b class="text-dark"> Before Check-In </b>
                          <i
                            class="fa fa-info-circle text-muted"
                            data-plugin="tippy"
                            data-tippy-animation="scale"
                            data-tippy-arrow="true"
                            v-b-popover.hover="
                              `Default check-in time is ${currentProps.hotelCheckinTime} local time.`
                            "
                          ></i>
                        </div>
                      </div>
                      <div id="charges_rule_div">
                        <p class="mt-3 text-blue">
                          <b
                            >Guests are charged for cancellations, as per the
                            rules below</b
                          >
                        </p>
                        <div
                          id="charges_row_div"
                          v-for="(policy, index) in cancellation_policy_charge"
                          :key="index"
                          :class="index"
                        >
                          <div class="row mt-2 align-items-center">
                            <div class="col-md-3">
                              <b-form-group
                                class="mb-3 form-label"
                                id="input-group-1"
                                label="Cancellation fee"
                                label-for="cp_cancellation_fee"
                              >
                                <template slot="label">
                                  Cancellation fee
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  class="form-select"
                                  id="cp_cancellation_fee"
                                  type="text"
                                  autocomplete="off"
                                  :options="cancellation_fee[index]"
                                  v-model="policy.cancellation_fee"
                                  :class="{
                                    'is-invalid':
                                      (submitted &&
                                        $v.cancellation_policy_charge.$each[
                                          index
                                        ].cancellation_fee.$error) ||
                                      cancellation_policy.is_error,
                                  }"
                                  @change="changeInCancellationFee(index)"
                                >
                                </b-form-select>
                                <div
                                  v-if="
                                    (submitted &&
                                      $v.cancellation_policy_charge.$each[index]
                                        .cancellation_fee.$error) ||
                                    cancellation_policy.is_error
                                  "
                                  class="invalid-feedback"
                                >
                                  <span v-if="cancellation_policy.is_error">{{
                                    cancellation_policy.error_message[0]
                                      .cancellation_fee[0]
                                  }}</span>
                                  <span
                                    v-if="
                                      !$v.cancellation_policy_charge.$each[
                                        index
                                      ].cancelled_within.required
                                    "
                                    >Cancellation fee is required.</span
                                  >
                                </div>
                              </b-form-group>
                            </div>

                            <div class="col-md-3">
                              <b-form-group
                                class="mb-3 form-label"
                                id="input-group-1"
                                label="Cancelled within"
                                label-for="cp_cancelled_within"
                              >
                                <template slot="label">
                                  Cancelled within
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  class="form-select"
                                  id="cp_cancelled_within"
                                  type="text"
                                  autocomplete="off"
                                  :options="cancelled_within[index]"
                                  v-model="policy.cancelled_within"
                                  :disabled="index == 0"
                                  :class="{
                                    'is-invalid':
                                      (submitted &&
                                        $v.cancellation_policy_charge.$each[
                                          index
                                        ].cancelled_within.$error) ||
                                      cancellation_policy.is_error,
                                  }"
                                  @change="changeInCancelledWithin(index)"
                                >
                                </b-form-select>
                                <div
                                  v-if="
                                    (submitted &&
                                      $v.cancellation_policy_charge.$each[index]
                                        .cancelled_within.$error) ||
                                    cancellation_policy.is_error
                                  "
                                  class="invalid-feedback"
                                >
                                  <span v-if="cancellation_policy.is_error">{{
                                    cancellation_policy.error_message[0]
                                      .cancellation_fee[0]
                                  }}</span>
                                  <span
                                    v-if="
                                      !$v.cancellation_policy_charge.$each[
                                        index
                                      ].cancelled_within.required
                                    "
                                    >Cancellation within is required.</span
                                  >
                                </div>
                              </b-form-group>
                            </div>

                            <div class="col-md-2 text-center text-dark">
                              of check-in <b>+</b>
                            </div>
                            <div class="col-md-2">
                              <b-form-group
                                class="mb-3"
                                id="example-number"
                                label="Flat fee"
                                label-for="cp_cancelled_flat_fee"
                              >
                                <template slot="label">
                                  Flat fee <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  id="number"
                                  value=""
                                  type="number"
                                  autocomplete="off"
                                  v-model="policy.flat_fee"
                                  placeholder="0.00"
                                  name="cp_cancelled_flat_fee"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.cancellation_policy_charge.$each[index]
                                        .flat_fee.$error,
                                  }"
                                ></b-form-input>
                                <div
                                  v-if="
                                    submitted &&
                                    $v.cancellation_policy_charge.$each[index]
                                      .flat_fee.$error
                                  "
                                  class="invalid-feedback"
                                >
                                  <span
                                    v-if="
                                      !$v.cancellation_policy_charge.$each[
                                        index
                                      ].flat_fee.required
                                    "
                                    >Cancellation flat fee is required.</span
                                  >
                                </div>
                              </b-form-group>
                            </div>
                            <div
                              class="col-md-2 text-dark align-items-center d-flex"
                            >
                              <i
                                v-if="index !== 0"
                                class="mdi mdi-trash-can fs-4"
                                @click="deleteCancellationPolicyCharge(index)"
                              ></i>
                            </div>
                          </div>
                        </div>
                        <p class="mt-3">
                          <a
                            href="javascript: void(0);"
                            @click="addCancellationPolicyCharge()"
                            id="add_row"
                            >+ add another</a
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
          >
            Cancel
          </b-button>
          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="onSubmit"
            :class="{ disabled: isBtnLoading }"
          >
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i
            >Update
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
